export default __webpack_public_path__ + "8bf41a5f48eca3a211442119466912b4.png";